import React, { useState } from "react";
import { Filter } from "./Filter";

export const Search = ({
  searchValue,
  setSearchValue,
  filterByCategory,
  setFilterByCategory,
  filterByColor,
  setFilterByColor,
  filterByWeight,
  setFilterByWeight,
  filterByPrice,
  setFilterByPrice,
  filterBySort,
  setFilterBySort,
}) => {
  const handleSearchInputChanges = (e) => {
    setSearchValue(e.value);
  };
  return (
    <form>
      <Filter
        filterByCategory={filterByCategory}
        setFilterByCategory={setFilterByCategory}
        filterByColor={filterByColor}
        setFilterByColor={setFilterByColor}
        filterByWeight={filterByWeight}
        setFilterByWeight={setFilterByWeight}
        filterByPrice={filterByPrice}
        setFilterByPrice={setFilterByPrice}
        filterBySort={filterBySort}
        setFilterBySort={setFilterBySort}
      />
    </form>
  );
};
